import { ChangeDetectorRef, Component, forwardRef, ViewEncapsulation, ChangeDetectionStrategy, AfterViewChecked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { VrCheckbox } from './models/vr-checkbox';

const VRC_CHECKBOX_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => VrcCheckboxComponent),
  multi: true
};

@Component({
  selector: 'vrc-checkbox',
  templateUrl: './vrc-checkbox.component.html',
  styleUrls: ['./vrc-checkbox.component.scss'],
  providers: [VRC_CHECKBOX_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrcCheckboxComponent extends VrCheckbox implements AfterViewChecked {
  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }
}
